import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * 로그인 다이얼로그 하단 액션 버튼들 컴포넌트
 * @param {object} props - 컴포넌트 props
 * @param {boolean} props.resetPasswordMode - 비밀번호 재설정 모드 여부
 * @param {boolean} props.isSignup - 회원가입 모드 여부
 * @param {function} props.setResetPasswordMode - 비밀번호 재설정 모드 설정 함수
 * @param {function} props.setResetPasswordEmail - 재설정 이메일 설정 함수
 * @param {function} props.setIsSignup - 회원가입 모드 설정 함수
 * @param {function} props.setPassword - 비밀번호 설정 함수
 * @param {function} props.resetFormState - 폼 상태 초기화 함수
 * @returns {JSX.Element} - 액션 버튼들
 */
const LoginDialogActions = ({
  resetPasswordMode,
  isSignup,
  setResetPasswordMode,
  setResetPasswordEmail,
  setIsSignup,
  setPassword,
  resetFormState
}) => {
  const { t } = useTranslation();

  const buttonStyle = {
    textTransform: 'none',
    color: '#1976d2',
    '&:hover': {
      bgcolor: 'rgba(25, 118, 210, 0.08)'
    }
  };

  if (resetPasswordMode) {
    return (
      <Button
        onClick={() => {
          setResetPasswordMode(false);
          setResetPasswordEmail('');
        }}
        sx={buttonStyle}
      >
        {t('auth.backToLogin')}
      </Button>
    );
  }

  return (
    <>
      <Button 
        onClick={() => {
          setIsSignup(!isSignup);
          setPassword('');
          resetFormState();
        }}
        sx={buttonStyle}
      >
        {isSignup ? t('auth.alreadyHaveAccount') : t('auth.noAccount')}
      </Button>
      {!isSignup && (
        <Button
          onClick={() => setResetPasswordMode(true)}
          sx={buttonStyle}
        >
          {t('auth.forgotPassword')}
        </Button>
      )}
    </>
  );
};

export default LoginDialogActions; 